const SIZES = {
  xs: "h-4 w-4 border-2",
  sm: "h-6 w-6 border-2",
  md: "h-10 w-10 border-[3px]",
  lg: "h-14 w-14 border-4",
};

const VARIANTS = {
  default: "border-primary-fixed-dim border-t-primary",
  light: "border-white/30 border-t-white",
};

const LoadingSpinner = ({ size = "md", variant = "default", className = "" }) => (
  <div role="status" className={`inline-flex ${className}`}>
    <div
      className={`rounded-full animate-spin ${SIZES[size] || SIZES.md} ${VARIANTS[variant] || VARIANTS.default}`}
      aria-hidden="true"
    />
    <span className="sr-only">Loading</span>
  </div>
);

export default LoadingSpinner;
